<template>
  <WarRoomPostPreviewPresenter
    :post="post"
    @on-add-vote="handleAddVote"
    @on-remove-vote="handleRemoveVote"
    @on-poll-vote="handlePollVote"
  />
</template>

<script lang="ts" setup>
import Vue from 'vue';
import { useContext, useStore } from '@nuxtjs/composition-api';
import WarRoomPostPreviewPresenter from '@/components/partials/war-room/WarRoomPostPreviewPresenter/WarRoomPostPreviewPresenter.vue';
import { votableTypes } from '@/components/partials/war-room/constants';
import type { IPost } from '@/types/community';
import type { RootState } from '@/types/store';

type WarRoomPostPreviewProps = {
  post: IPost;
};

const props = defineProps<WarRoomPostPreviewProps>();
const store = useStore<RootState>();
const { $analytics, $sentryUtils, $auth } = useContext();

async function handleAddVote(value: number): Promise<void> {
  $analytics?.logEvent(`war-room__post__rating__set`, { value });

  try {
    await store.dispatch('warRoom/addVote', { votable: props.post, type: votableTypes.POST, value });
  } catch (e) {
    if (e instanceof Error) {
      try {
        Vue.prototype.$notice.error(e);
      } catch (e) {
        // Supress error
      }
    }
    $sentryUtils.error(e);
  }
}

async function handleRemoveVote(): Promise<void> {
  $analytics?.logEvent(`war-room__post__rating__unset`);

  try {
    await store.dispatch('warRoom/removeVote', { votable: props.post, type: votableTypes.POST });
  } catch (e) {
    try {
      Vue.prototype.$notice.error(e);
    } catch (e) {
      // Supress error
    }
    $sentryUtils.error(e);
  }
}

async function handlePollVote(choiceId: number): Promise<void> {
  if (!$auth.loggedIn) {
    return;
  }

  try {
    $analytics?.logEvent('war-room__post-preview__poll-choice__click', { choiceId });
    await store.dispatch('warRoom/addPollChoice', { postSlug: props.post.slug, choiceId });
  } catch (e) {
    if (e instanceof Error) {
      try {
        Vue.prototype.$notice.error(e);
      } catch (e) {
        // Supress error
      }
    }
    $sentryUtils.error(e);
  }
}
</script>
